import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import featureFlags from 'common/helpers/featureFlags';

import { getProject } from '../project/projectSlice';
import FilesPageProjectLoader from './components/FilesPageProjectLoader';

import FilesPage from './FilesPage';
import LegacyFilesPage from './LegacyFilesPage';

/**
 * Router for Files
 *
 * - LegacyFilesPage -> This is the "old" page file with only files list
 * - FilesPage -> New FilesPage with both Files and Folders
 *
 * Feature flags:
 *
 * - EnableFileFeature (at project level): If that project has the complete feature enabled or not. If false non the new or legacy pages will be shown
 * - isEnabledFileFoldersFeature (REACT_APP_ENABLE_FILE_FOLDERS_FEATURE, at instance level): To show the new one (FilesPage) or the legacy/old one (LegacyFilesPage)
 */
const FileUploadContentRouter = () => {
  const project = useSelector(getProject);

  const projectSettingsLoaded = Object.prototype.hasOwnProperty.call(
    project,
    'EnableFileFeature'
  );

  const isEnabledFileFeature = project?.EnableFileFeature === 'true';
  const { isEnabledFileFoldersFeature } = featureFlags;

  const renderLoaderOrRedirectToProjectsRoutes = useCallback(() => {
    if (!projectSettingsLoaded) return <FilesPageProjectLoader />;
    if (projectSettingsLoaded && !isEnabledFileFeature)
      return <Redirect to={`/projects/${project?.id}`} />;
    return null;
  }, [isEnabledFileFeature, project?.id, projectSettingsLoaded]);

  const showLegacyFilesComponent =
    projectSettingsLoaded &&
    isEnabledFileFeature &&
    !isEnabledFileFoldersFeature;

  const showFilesFoldersComponent =
    projectSettingsLoaded &&
    isEnabledFileFeature &&
    isEnabledFileFoldersFeature;

  return (
    <Switch>
      <Route exact path="/projects/:projectId/files/">
        {renderLoaderOrRedirectToProjectsRoutes()}
        {showLegacyFilesComponent && <LegacyFilesPage />}
        {showFilesFoldersComponent && (
          <Redirect to={`/projects/${project?.id}/files/folders`} />
        )}
      </Route>
      <Route
        exact
        path={[
          '/projects/:projectId/files/folders',
          '/projects/:projectId/files/list',
        ]}
      >
        {renderLoaderOrRedirectToProjectsRoutes()}
        {showLegacyFilesComponent && <Redirect to="../files" />}
        {showFilesFoldersComponent && <FilesPage />}
      </Route>
      <Route path="/projects/:projectId/files/">
        <Redirect to="../files" />
      </Route>
    </Switch>
  );
};
export default FileUploadContentRouter;
